"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keys = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Get list with names of all own properties
 *
 * @tag Array,Object
 * @signature (source: Array|Object): string[]
 *
 * @param {Array|Object} source Array or Object to extract keys from
 *
 * @return  {string[]} List of property names
 *
 * @example
 * keys(["lorem", "ipsum"])
 * // => ["0", "1"]
 *
 * keys({ foo: "bar", lorem: "ipsum"})
 * // => ["foo", "lorem"]
 *
 * keys("foo"), keys(12), keys(null), etc
 * // => []
 */
var keys = function keys(source) {
  var type = Array.isArray(source) ? "array" : source !== null && _typeof(source) === "object" ? "object" : "other";

  switch (type) {
    case "object":
    case "array":
      {
        var entries = Object.entries(source);
        var result = [];

        for (var i = 0; i < entries.length; ++i) {
          result.push(entries[i][0]);
        }

        return result;
      }

    default:
      return [];
  }
};

exports.keys = keys;